import { STATUS_COLOR } from "@/lib/constants";

export function StatusPill({ status, testId }) {
  const c = STATUS_COLOR[status] || { bg: "#F1F5F9", fg: "#475569" };
  return (
    <span
      className="status-pill"
      style={{ background: c.bg, color: c.fg }}
      data-testid={testId}
    >
      {String(status || "—").replace(/_/g, " ")}
    </span>
  );
}
